/* src/app/ships/hull-swaps/hull-swaps.component.css */
.save-panel {
  margin-top: -10px;
  margin-right: -15px;
}
/*# sourceMappingURL=hull-swaps.component.css.map */
